import * as React from 'react';
import { ReactElement, useState } from 'react';
import BasicModal from 'components/common/modal/BasicModal';
import styled from 'styled-components';
import { TextField, Typography } from '@material-ui/core';
import { ColorText } from 'components/plansales/billing/detail/invoice/InvoiceTableRenderer';
import { downgradeToFree } from 'api/backorder';
import Button from 'components/common/Button';

interface Props {
  subscriptionId: number;
  onClose: () => void;
}

const DownGradeToFreePlanModal = ({ subscriptionId, onClose }: Props): ReactElement => {
  const [commentValue, setCommentValue] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onSubmit = async (): Promise<void> => {
    setIsLoading(true);
    await downgradeToFree({ subscriptionId, comment: commentValue });
    setIsLoading(false);
    window.location.reload();
  };
  return (
    <BasicModal
      open={true}
      onClose={onClose}
      title={'Downgrade to Free Plan'}
      actionButton={
        <>
          <Button variant={'text'} color={'default'} onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant={'text'}
            color={'primary'}
            onClick={onSubmit}
            disabled={!commentValue}
            isLoading={isLoading}
          >
            Confirm
          </Button>
        </>
      }
    >
      <Typography variant="subtitle1">
        Are you sure you want to downgrade to Free Plan for this Group?
      </Typography>
      <CommentWrapper>
        <Typography>
          Comment <ColorText color={'red'}> *</ColorText>
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant={'outlined'}
          value={commentValue}
          onChange={e => {
            setCommentValue(e.target.value);
          }}
          inputProps={{ maxLength: 500 }}
        />
      </CommentWrapper>
    </BasicModal>
  );
};

export default DownGradeToFreePlanModal;

const CommentWrapper = styled.div`
  margin: ${props => props.theme.spacing(3)}px 0px;
`;
